
    import '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-request/model.md?watch=parent';
    export const toc = [{"id":"zh-cn","depth":2,"title":"zh-CN"},{"id":"en-us","depth":2,"title":"en-US"}];
export const frontmatter = {"title":"Model","toc":"menu","filename":"docs/x-sdk/demos/x-request/model.md","lastUpdated":1763781754000,"description":"接入云服务平台，可发送请求、终止消息。"};